import addShortcut from '../../../common/rest/add-shortcut/index.tsx';

export type Request = {
	projectId: string;
	name: string;
	url: string;
	icon: string;
	type: string;
};

export type Response = {
	id: string;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (baseUrl: string, request: Request): Promise<Response> => {
	const result = await addShortcut(baseUrl, {
		...request,
	});
	return { id: result.id };
};
